import React from 'react';
import { MapPin, ChevronDown } from 'lucide-react';
export function LeftSidebar() {
  const navItems = ['Local News', 'Headlines', 'Posts', 'Newsletter', 'Topics', 'Reactions'];
  const footerLinks = ['About Us', 'Careers', 'Help Center', 'Contact', 'Blog'];
  return <aside className="hidden lg:flex flex-col h-screen sticky top-0 overflow-y-auto py-6 px-4 border-r border-gray-100" data-id="element-1110">
      {/* Logo */}
      <div className="mb-8" data-id="element-1111">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight text-gray-900" data-id="element-1112">
          <div className="relative w-8 h-8" data-id="element-1113">
            <div className="absolute inset-0 bg-red-500 transform skew-x-12 rounded-sm" data-id="element-1114"></div>
            <span className="absolute inset-0 flex items-center justify-center text-white font-black italic text-lg" data-id="element-1115">
              N
            </span>
          </div>
          NEWSBREAK
        </div>
      </div>

      {/* Location Selector */}
      <div className="mb-8" data-id="element-1116">
        <div className="flex items-start justify-between group cursor-pointer" data-id="element-1117">
          <div data-id="element-1118">
            <h2 className="text-xl font-bold text-gray-900 leading-tight mb-1" data-id="element-1119">
              Choose your
              <br data-id="element-1120" />
              location
            </h2>
          </div>
          <ChevronDown className="w-5 h-5 text-gray-500 mt-1" data-id="element-1121" />
        </div>
        <div className="mt-2 space-y-1" data-id="element-1122">
          <a href="#" className="block text-sm text-gray-500 hover:text-blue-600 underline decoration-gray-300" data-id="element-1123">
            See all locations
          </a>
          <div className="flex items-center gap-1 text-sm text-blue-600 cursor-pointer hover:underline" data-id="element-1124">
            <span data-id="element-1125">Customize your news</span>
            <span className="w-1.5 h-1.5 rounded-full bg-red-500" data-id="element-1126"></span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="space-y-1 mb-8" data-id="element-1127">
        {navItems.map(item => <a key={item} href="#" className="block py-2 text-gray-700 hover:text-red-500 hover:bg-gray-50 rounded-md transition-colors font-medium" data-id="element-1128">
            {item}
          </a>)}
      </nav>

      {/* Sign In Button */}
      <div className="mb-10" data-id="element-1129">
        <button className="w-full bg-gray-900 hover:bg-gray-800 text-white font-medium py-2.5 px-4 rounded-full transition-colors shadow-sm" data-id="element-1130">
          Sign In
        </button>
      </div>

      {/* Footer Links */}
      <div className="mt-auto" data-id="element-1131">
        <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3" data-id="element-1132">
          About NewsBreak
        </h3>
        <ul className="space-y-2" data-id="element-1133">
          {footerLinks.map(link => <li key={link} data-id="element-1134">
              <a href="#" className="text-xs text-gray-500 hover:text-gray-900 block" data-id="element-1135">
                {link}
              </a>
            </li>)}
        </ul>
      </div>
    </aside>;
}